<app-discount-sale-price *ngIf="discountGroup.subtype==='sale-ad'" [discountGroup]="discountGroup" (saved)="retrieveGroup()"></app-discount-sale-price>